/*
  Murray cart drawer — replaces the UpCart app.

  - Opens from the header cart icon and after any successful add to cart
    (theme product forms via ajaxProduct:added, anything else by watching
    /cart/add network requests).
  - Re-renders itself with the Section Rendering API so prices, compare-at
    prices and automatic discounts come straight from Liquid.
  - The checkout button is a normal name="checkout" submit with
    data-lasso-checkout, so the Lasso/Whop checkout script picks it up.
*/
(function () {
  if (window.__murrayCartReady) return;
  window.__murrayCartReady = true;

  var SECTION = 'murray-cart';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var openTimer = null;
  var lastFocus = null;

  function drawer() {
    return document.getElementById('MurrayCart');
  }

  function isCartAdd(url) {
    try {
      var path = new URL(url, location.origin).pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/');
      return /^\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }
  }

  function updateBubbles(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', count > 0);
    });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
      el.textContent = count;
    });
  }

  function apply(html) {
    var current = drawer();
    if (!current || !html) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var next = tmp.querySelector('#MurrayCart');
    if (!next) return;

    var scroll = current.querySelector('.mc__body');
    var scrollTop = scroll ? scroll.scrollTop : 0;
    var oldFill = current.querySelector('[data-mc-tiers-fill]');
    var fillFrom = oldFill ? oldFill.style.width : '';

    current.querySelector('.mc__panel').innerHTML = next.querySelector('.mc__panel').innerHTML;
    current.dataset.count = next.dataset.count;

    // The tier bar is a new element after every render: start it at the old width so it slides
    var newFill = current.querySelector('[data-mc-tiers-fill]');
    if (newFill && fillFrom && fillFrom !== newFill.style.width) {
      var fillTo = newFill.style.width;
      newFill.style.width = fillFrom;
      void newFill.offsetWidth;
      newFill.style.width = fillTo;
    }

    var newScroll = current.querySelector('.mc__body');
    if (newScroll) newScroll.scrollTop = scrollTop;

    updateBubbles(parseInt(next.dataset.count, 10) || 0);
    showPending();
  }

  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) { apply(data[SECTION]); })
      .catch(function (e) { console.error('[MurrayCart]', e); });
  }

  // mode 'instant' (theme editor): no slide animation and no focus change.
  // Any other value — including the resolved value of refresh().then(open) — opens normally.
  function open(mode) {
    var el = drawer();
    if (!el || el.classList.contains('is-open')) return;
    var instant = mode === 'instant';
    lastFocus = instant ? null : document.activeElement;
    if (instant) el.classList.add('mc--instant');
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mc-lock');
    if (instant) {
      void el.offsetWidth;
      requestAnimationFrame(function () { el.classList.remove('mc--instant'); });
    } else {
      var panel = el.querySelector('.mc__panel');
      if (panel) panel.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('drawerOpen'));
  }

  function close() {
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    closePicker();
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function refreshAndOpen() {
    clearTimeout(openTimer);
    refresh().then(open);
  }

  // Quantities asked for while a change was running, sent one by one once it is done.
  // Shopify gives every line a new key after each change, so a queued line is remembered by
  // its position and variant id and looked up again in the freshly rendered drawer.
  var pending = [];

  function cartLines() {
    return document.querySelectorAll('#MurrayCart .mc__item[data-key]');
  }

  function variantOf(line) {
    return line.dataset.key.split(':')[0];
  }

  function findLine(entry) {
    var lines = cartLines();
    var line = lines[entry.index];
    if (line && variantOf(line) === entry.variant) return line;
    return Array.prototype.find.call(lines, function (l) { return variantOf(l) === entry.variant; }) || null;
  }

  function queue(line, quantity) {
    var index = Array.prototype.indexOf.call(cartLines(), line);
    var variant = variantOf(line);
    var entry = pending.find(function (p) { return p.variant === variant && p.index === index; });
    if (entry) entry.quantity = quantity;
    else pending.push({ index: index, variant: variant, quantity: quantity });
  }

  // A re-render shows the server quantity; lines with a queued change keep showing what was asked
  function showPending() {
    pending.forEach(function (entry) {
      var line = findLine(entry);
      if (!line) return;
      entry.index = Array.prototype.indexOf.call(cartLines(), line);
      var input = line.querySelector('[data-mc-input]');
      if (input) input.value = entry.quantity;
    });
  }

  function change(line, quantity) {
    if (!line || !line.dataset.key) return;
    quantity = Math.max(0, quantity);
    if (busy) {
      queue(line, quantity);
      return;
    }
    busy = true;
    var el = drawer();
    el.classList.add('is-loading');

    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.dataset.key, quantity: quantity, sections: SECTION })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION]) {
          apply(data.sections[SECTION]);
        } else {
          pending = [];
          if (data && data.description) window.alert(data.description);
          return refresh();
        }
      })
      .catch(function (e) {
        console.error('[MurrayCart]', e);
        pending = [];
        return refresh();
      })
      .finally(function () {
        busy = false;
        // Next queued line that is still in the drawer (a removed line drops its queue)
        while (pending.length) {
          var entry = pending.shift();
          var next = findLine(entry);
          if (!next) continue;
          var input = next.querySelector('[data-mc-input]');
          if (input) input.value = entry.quantity;
          change(next, entry.quantity);
          return;
        }
        el.classList.remove('is-loading');
      });
  }

  // Header cart icon (capture phase so no other handler navigates to /cart)
  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('.js-drawer-open-cart');
    if (!trigger || document.body.classList.contains('template-cart')) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    open();
  }, true);

  // Clicks inside the drawer
  document.addEventListener('click', function (evt) {
    var el = drawer();
    if (!el || !el.contains(evt.target)) return;

    if (evt.target.closest('[data-mc-close]')) {
      evt.preventDefault();
      close();
      return;
    }

    var qtyBtn = evt.target.closest('[data-mc-qty]');
    if (qtyBtn) {
      evt.preventDefault();
      var item = qtyBtn.closest('[data-key]');
      if (!item) return;
      var input = item.querySelector('[data-mc-input]');
      var quantity = parseInt(qtyBtn.dataset.mcQty, 10);
      // + / − count from the number on screen (defaultValue = quantity of the last render),
      // so quick clicks add up while the cart is still answering
      if (input && !qtyBtn.classList.contains('mc__remove')) {
        var shown = parseInt(input.value, 10);
        var rendered = parseInt(input.defaultValue, 10);
        if (!isNaN(shown) && !isNaN(rendered)) quantity = Math.max(0, shown + (quantity > rendered ? 1 : -1));
      }
      if (input) input.value = quantity;
      change(item, quantity);
    }
  });

  document.addEventListener('change', function (evt) {
    var input = evt.target.closest && evt.target.closest('#MurrayCart [data-mc-input]');
    if (!input) return;
    var item = input.closest('[data-key]');
    var qty = parseInt(input.value, 10);
    change(item, isNaN(qty) ? 0 : qty);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') {
      // Escape closes the variant picker first, the drawer on the next press
      if (picker) closePicker();
      else close();
    }
    if (evt.key === 'Enter' && evt.target.matches && evt.target.matches('#MurrayCart [data-mc-input]')) {
      evt.preventDefault();
      evt.target.blur();
    }
  });

  // Keep the drawer in sync with theme events
  document.addEventListener('cart:open', function () { refresh().then(open); });
  document.addEventListener('cart:close', close);
  document.addEventListener('cart:build', refresh);
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) refresh();
  });

  // Theme product forms: success events carry the added product. theme.js asks for this
  // section with the add, so its HTML is used directly; without it, fall back to a refresh.
  document.addEventListener('ajaxProduct:added', function (evt) {
    var product = evt.detail && evt.detail.product;
    var html = product && product.sections && product.sections[SECTION];
    if (html) {
      clearTimeout(openTimer);
      apply(html);
      open();
    } else if (product) {
      refreshAndOpen();
    } else {
      refresh();
    }
  });

  // Any other add to cart (apps, quick add). Watching finished network
  // requests instead of wrapping fetch, because the Lasso checkout script
  // replaces window.fetch after this file runs.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (!isCartAdd(entry.name)) return;
          // Adds that already returned this section's HTML (marked by the sender)
          if (/[?&]mc_sections=1(&|$)/.test(entry.name)) return;
          if (entry.responseStatus && entry.responseStatus >= 400) return;
          var before = parseInt((drawer() || {}).dataset ? drawer().dataset.count : 0, 10) || 0;
          clearTimeout(openTimer);
          openTimer = setTimeout(function () {
            refresh().then(function () {
              var after = parseInt(drawer().dataset.count, 10) || 0;
              if (after > before) open();
            });
          }, 120);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  // ---------------------------------------------------------------------------
  // Upsell slider + variant picker. Everything is delegated on document, so the
  // re-rendered markup works without re-binding and nothing is bound twice.
  // ---------------------------------------------------------------------------
  var picker = null;

  function upsellState(track) {
    var cards = track.querySelectorAll('[data-mc-upsell-card]');
    var width = track.clientWidth || 1;
    var index = Math.round(track.scrollLeft / width);
    return { count: cards.length, index: Math.max(0, Math.min(cards.length - 1, index)), width: width };
  }

  function syncUpsell(upsell) {
    var track = upsell.querySelector('[data-mc-upsell-track]');
    if (!track) return;
    var s = upsellState(track);
    var loop = upsell.dataset.loop === 'true';
    upsell.querySelectorAll('[data-mc-upsell-nav]').forEach(function (btn) {
      var dir = parseInt(btn.dataset.mcUpsellNav, 10);
      btn.disabled = !loop && (dir < 0 ? s.index === 0 : s.index === s.count - 1);
    });
    upsell.querySelectorAll('[data-mc-upsell-dot]').forEach(function (dot) {
      dot.classList.toggle('is-active', parseInt(dot.dataset.mcUpsellDot, 10) === s.index);
    });
  }

  function goToCard(upsell, index) {
    var track = upsell.querySelector('[data-mc-upsell-track]');
    if (!track) return;
    var s = upsellState(track);
    if (upsell.dataset.loop === 'true') index = (index + s.count) % s.count;
    index = Math.max(0, Math.min(s.count - 1, index));
    track.scrollTo({ left: index * s.width, behavior: 'smooth' });
  }

  var TRACK = '#MurrayCart [data-mc-upsell-track]';

  // scroll does not bubble: listen in the capture phase and pick out upsell tracks.
  // Arrows and dots follow swipes too (debounced, plus once per frame while moving).
  document.addEventListener('scroll', function (evt) {
    var track = evt.target;
    if (!track || !track.matches || !track.matches(TRACK)) return;
    var upsell = track.closest('[data-mc-upsell]');
    if (!track._mcFrame) {
      track._mcFrame = requestAnimationFrame(function () { track._mcFrame = 0; syncUpsell(upsell); });
    }
    clearTimeout(track._mcSettle);
    track._mcSettle = setTimeout(function () { syncUpsell(upsell); }, 80);
  }, true);

  // Touches that start in the slider never reach page-level touch handlers (theme, apps,
  // analytics), so nothing up there can preventDefault a swipe. The shield is attached to the
  // track during the capture phase of its first touch, which still covers that same touch;
  // re-rendered tracks are new elements and get their own shield on first touch.
  function shield(evt) { evt.stopPropagation(); }

  // Swipe vs tap: a finger that moved more than 8px is a swipe, so the click that some
  // browsers still fire afterwards must not open the product link.
  var touchStart = null;
  var swipedAt = 0;

  document.addEventListener('touchstart', function (evt) {
    var track = evt.target.closest && evt.target.closest(TRACK);
    if (!track) { touchStart = null; return; }
    if (!track._mcShielded) {
      track._mcShielded = true;
      ['touchstart', 'touchmove', 'touchend'].forEach(function (type) {
        track.addEventListener(type, shield, { passive: true });
      });
    }
    var t = evt.touches[0];
    touchStart = { x: t.clientX, y: t.clientY, moved: false };
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', function (evt) {
    if (!touchStart || touchStart.moved) return;
    var t = evt.touches[0];
    if (Math.abs(t.clientX - touchStart.x) > 8 || Math.abs(t.clientY - touchStart.y) > 8) touchStart.moved = true;
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function () {
    if (touchStart && touchStart.moved) swipedAt = Date.now();
    touchStart = null;
  }, { capture: true, passive: true });

  document.addEventListener('click', function (evt) {
    if (Date.now() - swipedAt > 600) return;
    var link = evt.target.closest && evt.target.closest(TRACK + ' a');
    if (!link) return;
    evt.preventDefault();
    evt.stopPropagation();
  }, true);

  function cartAdd(variantId) {
    // mc_sections=1: the network watcher below skips this add (the response re-renders already)
    return fetch(root + 'cart/add.js?mc_sections=1', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: SECTION })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add this product.');
        }
        return data;
      });
    }).then(function (data) {
      if (data.sections && data.sections[SECTION]) apply(data.sections[SECTION]);
      else return refresh();
    });
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function addFromCard(btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var card = btn.closest('[data-mc-upsell-card]');
    var error = card && card.querySelector('[data-mc-upsell-error]');
    showError(error, '');
    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    cartAdd(parseInt(btn.dataset.mcUpsellAdd, 10)).catch(function (e) {
      // the card is still there when the add failed
      showError(error, e.message);
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
  }

  // -- variant picker ---------------------------------------------------------
  function findVariant(data, values) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var match = true;
      for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { match = false; break; }
      if (match) return v;
    }
    return null;
  }

  // First available variant that keeps the options up to `upTo` as chosen
  function bestVariant(data, values, upTo) {
    var exact = findVariant(data, values);
    if (exact && exact.available) return exact;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (!v.available) continue;
      var match = true;
      for (var j = 0; j <= upTo; j++) if (v.options[j] !== values[j]) { match = false; break; }
      if (match) return v;
    }
    return exact;
  }

  function pickerValues() {
    return picker.controls.map(function (c) { return c.get(); });
  }

  function renderPicker() {
    var p = picker;
    var values = pickerValues();
    var variant = findVariant(p.data, values);

    // A value counts as available when an available variant has it together with the options chosen before it
    p.controls.forEach(function (control, index) {
      control.values.forEach(function (value) {
        var exists = false, available = false;
        p.data.variants.forEach(function (v) {
          if (v.options[index] !== value) return;
          for (var j = 0; j < index; j++) if (v.options[j] !== values[j]) return;
          exists = true;
          if (v.available) available = true;
        });
        control.mark(value, available ? 'ok' : exists ? 'soldout' : 'none');
      });
    });

    var img = (variant && variant.image) || p.data.image;
    p.img.hidden = !img;
    if (img) p.img.src = img;
    p.variantName.textContent = variant ? variant.title : '';
    p.price.textContent = variant ? variant.price : '';
    p.compare.textContent = variant && variant.compare ? variant.compare : '';
    p.compare.hidden = !(variant && variant.compare);
    var ok = !!(variant && variant.available);
    p.addBtn.disabled = !ok;
    p.addBtn.textContent = ok ? p.addText : p.soldoutText;
    p.variant = variant;
  }

  // One option as radio buttons (same look as the product page, Theme settings → Variant buttons)
  function buttonControl(name, index, values, soldoutStyle, soldoutText) {
    var field = document.createElement('fieldset');
    field.className = 'mc__picker-field';
    var legend = document.createElement('legend');
    legend.className = 'mc__picker-legend';
    legend.textContent = name;
    var group = document.createElement('div');
    group.className = 'mc__picker-values';
    var items = {};
    values.forEach(function (value, k) {
      var item = document.createElement('div');
      item.className = 'mc__picker-value';
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'mc-picker-option-' + index;
      input.id = 'mc-picker-' + index + '-' + k;
      input.value = value;
      input.dataset.mcPickerOption = index;
      var label = document.createElement('label');
      label.className = 'variant__button-label';
      label.setAttribute('for', input.id);
      label.textContent = value;
      item.appendChild(input);
      item.appendChild(label);
      group.appendChild(item);
      items[value] = { item: item, input: input, label: label };
    });
    field.appendChild(legend);
    field.appendChild(group);
    return {
      el: field,
      values: values,
      get: function () { var c = group.querySelector('input:checked'); return c ? c.value : null; },
      set: function (value) { if (items[value]) items[value].input.checked = true; },
      focusTarget: function () { return group.querySelector('input:checked') || group.querySelector('input'); },
      mark: function (value, state) {
        var it = items[value];
        var off = state !== 'ok';
        it.label.classList.toggle('disabled', off);
        it.label.title = state === 'soldout' ? soldoutText : '';
        it.input.disabled = off && !it.input.checked && soldoutStyle === 'not_clickable';
        it.item.hidden = off && !it.input.checked && soldoutStyle === 'hide';
      }
    };
  }

  // One option as a <select> (Theme settings → Variant buttons → Style: Dropdown)
  function selectControl(name, index, values, soldoutText) {
    var id = 'mc-picker-' + index;
    var field = document.createElement('div');
    field.className = 'mc__picker-field';
    var label = document.createElement('label');
    label.setAttribute('for', id);
    label.textContent = name;
    var select = document.createElement('select');
    select.id = id;
    select.dataset.mcPickerOption = index;
    values.forEach(function (value) {
      var opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      select.appendChild(opt);
    });
    var wrap = document.createElement('span');
    wrap.className = 'mc__picker-select';
    wrap.appendChild(select);
    field.appendChild(label);
    field.appendChild(wrap);
    return {
      el: field,
      values: values,
      get: function () { return select.value; },
      set: function (value) { select.value = value; },
      focusTarget: function () { return select; },
      mark: function (value, state) {
        var opt = Array.prototype.find.call(select.options, function (o) { return o.value === value; });
        opt.disabled = state !== 'ok';
        opt.textContent = value + (state === 'soldout' ? ' (' + soldoutText + ')' : '');
      }
    };
  }

  function closePicker() {
    if (!picker) return;
    var p = picker;
    picker = null;
    p.el.classList.remove('is-open');
    document.removeEventListener('keydown', p.trap, true);
    setTimeout(function () { p.el.remove(); }, 250);
    if (p.opener && document.contains(p.opener)) p.opener.focus({ preventScroll: true });
  }

  function openPicker(btn) {
    var card = btn.closest('[data-mc-upsell-card]');
    var upsell = btn.closest('[data-mc-upsell]');
    var json = card && card.querySelector('[data-mc-upsell-json]');
    if (!json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { console.error('[MurrayCart]', e); return; }
    closePicker();

    var el = document.createElement('div');
    el.className = 'mc__picker';
    el.innerHTML =
      '<div class="mc__picker-backdrop" data-mc-picker-close></div>' +
      '<div class="mc__picker-sheet" role="dialog" aria-modal="true" tabindex="-1">' +
        '<button type="button" class="mc__picker-close" data-mc-picker-close aria-label="Close">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m11.414 10 6.293-6.293a1 1 0 1 0-1.414-1.414l-6.293 6.293-6.293-6.293a1 1 0 0 0-1.414 1.414l6.293 6.293-6.293 6.293a1 1 0 1 0 1.414 1.414l6.293-6.293 6.293 6.293a1 1 0 0 0 1.414-1.414z"/></svg>' +
        '</button>' +
        '<div class="mc__picker-head">' +
          '<img class="mc__picker-image" alt="" width="80" height="80">' +
          '<div class="mc__picker-meta">' +
            '<p class="mc__picker-title"></p>' +
            '<p class="mc__picker-variant"></p>' +
            '<p class="mc__picker-prices"><span class="mc__picker-price"></span> <s class="mc__picker-compare"></s></p>' +
          '</div>' +
        '</div>' +
        '<div class="mc__picker-options"></div>' +
        '<p class="mc__picker-error" role="alert" hidden></p>' +
        '<button type="button" class="mc__picker-add" data-mc-picker-add></button>' +
      '</div>';

    var sheet = el.querySelector('.mc__picker-sheet');
    sheet.setAttribute('aria-label', data.title);
    el.querySelector('.mc__picker-title').textContent = data.title;
    var optionsWrap = el.querySelector('.mc__picker-options');
    var initial = null;
    data.variants.forEach(function (v) { if (v.id === data.initial) initial = v; });
    initial = initial || data.variants[0];

    var style = (upsell && upsell.dataset.variantStyle) || 'dropdown';
    var soldoutStyle = (upsell && upsell.dataset.soldoutStyle) || 'clickable';
    var soldoutText = (upsell && upsell.dataset.pickerSoldout) || 'Sold out';
    var controls = data.options.map(function (name, index) {
      var values = [];
      data.variants.forEach(function (v) { if (values.indexOf(v.options[index]) < 0) values.push(v.options[index]); });
      var control = style === 'dropdown'
        ? selectControl(name, index, values, soldoutText)
        : buttonControl(name, index, values, soldoutStyle, soldoutText);
      control.set(initial.options[index]);
      optionsWrap.appendChild(control.el);
      return control;
    });

    picker = {
      el: el,
      data: data,
      controls: controls,
      soldoutStyle: style === 'dropdown' ? 'not_clickable' : soldoutStyle,
      opener: btn,
      img: el.querySelector('.mc__picker-image'),
      variantName: el.querySelector('.mc__picker-variant'),
      price: el.querySelector('.mc__picker-price'),
      compare: el.querySelector('.mc__picker-compare'),
      error: el.querySelector('.mc__picker-error'),
      addBtn: el.querySelector('[data-mc-picker-add]'),
      addText: (upsell && upsell.dataset.pickerAdd) || 'Add to cart',
      soldoutText: (upsell && upsell.dataset.pickerSoldout) || 'Sold out',
      // keep Tab inside the sheet while it is open
      trap: function (evt) {
        if (evt.key !== 'Tab' || !picker) return;
        var focusable = picker.el.querySelectorAll('button:not([disabled]), select, input[type="radio"]:checked');
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
        else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
      }
    };
    renderPicker();

    drawer().appendChild(el);
    document.addEventListener('keydown', picker.trap, true);
    void el.offsetWidth;
    el.classList.add('is-open');
    (controls[0] ? controls[0].focusTarget() : sheet).focus({ preventScroll: true });
  }

  function addFromPicker() {
    var p = picker;
    if (!p || !p.variant || !p.variant.available || p.addBtn.classList.contains('is-loading')) return;
    showError(p.error, '');
    p.addBtn.classList.add('is-loading');
    p.addBtn.disabled = true;
    p.addBtn.setAttribute('aria-busy', 'true');
    cartAdd(p.variant.id).then(function () {
      if (picker === p) closePicker();
    }).catch(function (e) {
      showError(p.error, e.message);
      p.addBtn.classList.remove('is-loading');
      p.addBtn.removeAttribute('aria-busy');
      renderPicker();
    });
  }

  document.addEventListener('click', function (evt) {
    var el = drawer();
    if (!el || !el.contains(evt.target)) return;

    var nav = evt.target.closest('[data-mc-upsell-nav]');
    if (nav) {
      var navRoot = nav.closest('[data-mc-upsell]');
      var track = navRoot.querySelector('[data-mc-upsell-track]');
      goToCard(navRoot, upsellState(track).index + parseInt(nav.dataset.mcUpsellNav, 10));
      return;
    }
    var dot = evt.target.closest('[data-mc-upsell-dot]');
    if (dot) {
      goToCard(dot.closest('[data-mc-upsell]'), parseInt(dot.dataset.mcUpsellDot, 10));
      return;
    }
    var add = evt.target.closest('[data-mc-upsell-add]');
    if (add) {
      evt.preventDefault();
      addFromCard(add);
      return;
    }
    var pick = evt.target.closest('[data-mc-upsell-pick]');
    if (pick) {
      evt.preventDefault();
      openPicker(pick);
      return;
    }
    if (evt.target.closest('[data-mc-picker-close]')) {
      closePicker();
      return;
    }
    if (evt.target.closest('[data-mc-picker-add]')) addFromPicker();
  });

  document.addEventListener('change', function (evt) {
    var input = evt.target.closest && evt.target.closest('#MurrayCart [data-mc-picker-option]');
    if (!input || !picker) return;
    var index = parseInt(input.dataset.mcPickerOption, 10);
    var values = pickerValues();
    var exact = findVariant(picker.data, values);
    var variant = exact && (exact.available || picker.soldoutStyle === 'clickable') ? exact : bestVariant(picker.data, values, index);
    if (!variant) {
      // nothing available with this value: show an existing (sold-out) combination with it
      picker.data.variants.some(function (v) {
        for (var j = 0; j <= index; j++) if (v.options[j] !== values[j]) return false;
        variant = v;
        return true;
      });
    }
    if (variant) picker.controls.forEach(function (c, i) { c.set(variant.options[i]); });
    showError(picker.error, '');
    renderPicker();
  });

  // Theme editor only: keep the drawer open while its own section is selected/edited.
  // Every listener here is on document and this file runs once, so section reloads
  // never attach anything twice.
  if (window.Shopify && Shopify.designMode) {
    // Survives full preview reloads (e.g. a Theme settings colour change)
    var EDITOR_KEY = 'murrayCartSectionSelected';
    var reopenAfterLoad = false;

    var isCartSection = function (evt) {
      return (evt.detail && evt.detail.sectionId === SECTION) ||
        (evt.target && evt.target.id === 'shopify-section-' + SECTION);
    };
    var setSelected = function (on) {
      try {
        if (on) sessionStorage.setItem(EDITOR_KEY, '1');
        else sessionStorage.removeItem(EDITOR_KEY);
      } catch (e) {}
    };
    var isSelected = function () {
      try { return sessionStorage.getItem(EDITOR_KEY) === '1'; } catch (e) { return false; }
    };

    document.addEventListener('shopify:section:select', function (evt) {
      if (!isCartSection(evt)) return;
      setSelected(true);
      open('instant');
    });

    document.addEventListener('shopify:section:deselect', function (evt) {
      if (!isCartSection(evt)) return;
      setSelected(false);
      close();
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      if (!isCartSection(evt)) return;
      var el = drawer();
      reopenAfterLoad = !!(el && el.classList.contains('is-open'));
      // The old drawer is about to be removed: never leave the scroll lock behind
      document.documentElement.classList.remove('mc-lock');
    });

    document.addEventListener('shopify:section:load', function (evt) {
      if (!isCartSection(evt)) return;
      if (reopenAfterLoad || isSelected()) open('instant');
      reopenAfterLoad = false;
    });

    if (isSelected()) open('instant');
  }

  // Not window.MurrayCart: the #MurrayCart element already owns that global name
  window.murrayCartDrawer = { open: open, close: close, refresh: refresh };
})();
